import { createStore, applyMiddleware, compose as defaultCompose, combineReducers } from 'redux'
import reducers from './reducers'
import { keaSaga } from 'kea-saga'
import { connectRoutes } from 'redux-first-router'
import restoreScroll from 'redux-first-router-restore-scroll'
import routesMap, { options } from './routesMap'
import { nprogressMiddleware } from 'redux-nprogress';
import createSagaMiddleware from 'redux-saga'
import {canUseDom} from "./utils/dom"
import sagas from "./sagas"
import googleTagManager from "./middleware/googleTagManager"
import applyScreenMiddleware from './middleware/applyScreenMiddleware'

import {STATE_PRELOADED} from "./actions"

export default function(history, keaScenesReducer) {

    const sagaMiddleware = createSagaMiddleware()

    const { reducer, middleware, enhancer, thunk } = connectRoutes(
        history,
        routesMap,
        {
            ...options,
            restoreScroll: canUseDom && restoreScroll({ manual: true })
        }
    )

    let compose = defaultCompose
    /* global __REDUX_DEVTOOLS_EXTENSION_COMPOSE__:false */
    //if (process.env.NODE_ENV !== 'production' && typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
    if ( typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
        // in development mode, if you install the Redux Devtools extension (see https://github.com/zalmoxisus/redux-devtools-extension)
        // then this will connect to the dev tools and allow you to inspect Redux state
        compose = __REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }

    const rootReducer = combineReducers({
        scenes: keaScenesReducer,
        ...reducers,
        location: reducer,
    });
    const middlewares = applyMiddleware(
        middleware,
        nprogressMiddleware(),
        sagaMiddleware,
        googleTagManager
        //thunk,
    )
    const enhancers = compose(enhancer, middlewares)

    // Grab the state from a global variable injected into the server-generated HTML
    const preloadedState = typeof window !== 'undefined' ? window.__PRELOADED_STATE__ : undefined
    if (preloadedState) {
        // Allow the passed state to be garbage-collected
        delete window.__PRELOADED_STATE__
    }

    // Create Redux store with initial state, if specified
    const store = createStore(rootReducer, preloadedState, enhancers)

    // then run the saga
    sagaMiddleware.run(sagas)
    sagaMiddleware.run(keaSaga)

    if (preloadedState) {
        store.dispatch({type: STATE_PRELOADED});
    }

    applyScreenMiddleware(store);

    if (module.hot && process.env.NODE_ENV === 'development') {
        module.hot.accept('./reducers/index', () => {
            const reducers = require('./reducers/index')
            const rootReducer = combineReducers({ ...reducers, location: reducer })
            store.replaceReducer(rootReducer)
        })
    }

    return { store, thunk }
}



// WEBPACK FOOTER //
// ./src/store.js